var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo, useState, } from 'react';
import { ARROW_DOWN_KEY, ARROW_LEFT_KEY, ARROW_RIGHT_KEY, ARROW_UP_KEY, } from '#constants';
// The header row is navigated as a virtual row that sits above the first data
// row (index 0). Only individual header cells can be active - never the whole
// row - so the header state is always paired with a non-null focusable cell.
export const HEADER_ROW_INDEX = -1;
export const useArrowKeysNavigation = ({ cellsCount, containerRef, data, focusedRowRefCondition, isHeaderNavigable = false, }) => {
    _react_refresh_temp_1();
    const rowsCount = data.length;
    const [shouldFocusRow, setShouldFocusRow] = useState(false);
    const focusableRowIndex = useMemo(() => {
        if (!focusedRowRefCondition) {
            return 0;
        }
        const foundIndex = data.findIndex(focusedRowRefCondition);
        if (foundIndex > -1) {
            setShouldFocusRow(true);
        }
        return foundIndex !== -1 ? foundIndex : 0;
    }, [data, focusedRowRefCondition]);
    const [focusableRow, setFocusableRow] = useState(focusableRowIndex);
    const [focusableCell, setFocusableCell] = useState(null);
    const handleKey = useCallback((event) => {
        let isHandled = false;
        const isInHeader = focusableRow === HEADER_ROW_INDEX;
        switch (event.key) {
            case ARROW_DOWN_KEY:
                // Leaving the header returns to the first data row, keeping
                // the same column active.
                setFocusableRow((prev) => prev === HEADER_ROW_INDEX
                    ? 0
                    : prev < rowsCount - 1
                        ? prev + 1
                        : 0);
                isHandled = true;
                break;
            case ARROW_UP_KEY:
                if (isInHeader) {
                }
                else if (isHeaderNavigable &&
                    focusableRow === 0 &&
                    focusableCell !== null) {
                    // Enter the header only from a cell in the first data
                    // row - not from a whole-row selection.
                    setFocusableRow(HEADER_ROW_INDEX);
                }
                else {
                    setFocusableRow((prev) => prev > 0 ? prev - 1 : rowsCount - 1);
                }
                isHandled = true;
                break;
            case ARROW_RIGHT_KEY:
                setFocusableCell((prev) => {
                    if (prev === null) {
                        return 0;
                    }
                    if (prev < cellsCount - 1) {
                        return prev + 1;
                    }
                    return 0;
                });
                isHandled = true;
                break;
            case ARROW_LEFT_KEY:
                setFocusableCell((prev) => {
                    if (prev === null) {
                        return null;
                    }
                    if (prev > 0) {
                        return prev - 1;
                    }
                    // The header never releases to a whole-row state, so
                    // the leftmost cell wraps to the last one instead.
                    return isInHeader ? cellsCount - 1 : null;
                });
                isHandled = true;
                break;
            default:
                break;
        }
        if (isHandled) {
            setShouldFocusRow(true);
            event.preventDefault();
            event.stopPropagation();
        }
    }, [cellsCount, rowsCount, focusableRow, focusableCell, isHeaderNavigable]);
    const handleBlur = useCallback((event) => {
        if (event.relatedTarget &&
            !containerRef.current?.contains(event.relatedTarget)) {
            setShouldFocusRow(false);
            setFocusableRow(0);
            setFocusableCell(null);
        }
    }, [containerRef]);
    return {
        focusableCell,
        focusableRow,
        handleBlur,
        handleKey,
        shouldFocusRow,
    };
};
_react_refresh_temp_1(useArrowKeysNavigation, "HBz0jE36jhl8JNBu5iUyvvNNB7k=");
